// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for PrescriptionSetProcedure Model Structure
 * @see #/components/schemas/MinimalPrescriptionSetProcedure - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface MinimalPrescriptionSetProcedure {
    id: string;
    description: string;
    readonly category: string;
    readonly frequency: string;
    readonly frequency_times: Array<string>;
    instructions: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for MinimalPrescriptionSetProcedure
 */
export namespace MinimalPrescriptionSetProcedure {
    /**
     * MinimalPrescriptionSetProcedure Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        id: string;
        description: string;
        readonly category: string;
        readonly frequency: string;
        readonly frequencyTimes: Array<string>;
        instructions: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * MinimalPrescriptionSetProcedure DTO
     * Transforms MinimalPrescriptionSetProcedure model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend MinimalPrescriptionSetProcedure model */
        static toModel(obj: MinimalPrescriptionSetProcedure): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend MinimalPrescriptionSetProcedure model */
        static toApi(obj: Model): MinimalPrescriptionSetProcedure {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as MinimalPrescriptionSetProcedure;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
